// extracted by mini-css-extract-plugin
module.exports = {"edit_form":"AddDatasource_edit_form__1v6Fm"};